// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2IG5u","row":"Node_row__iPmlH","label":"Node_label__1-r8m","footer":"Node_footer__1a6ag"};